import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import { AlertWrapper } from "@root/components";

function OpenLayout() {
  return (
    <AlertWrapper>
      <Box
        bg="theme.bg.container"
        width={{ base: "100%" }}
        height={"100vh"}
        px={{ base: "16px", sm: "10vw" }}
        py={"16px"}
      >
        <Box width={{ base: "100%", lg: "1100px" }} height={"100%"} m={"auto"}>
          <Outlet />
        </Box>
      </Box>
    </AlertWrapper>
  );
}

export default OpenLayout;
